import script from "./Livechat.vue?vue&type=script&setup=true&lang=js"
export * from "./Livechat.vue?vue&type=script&setup=true&lang=js"

import "./Livechat.vue?vue&type=style&index=0&id=40673b2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40673b2c"]])

export default __exports__